import { dataManagerActionType, notificationActionTypes } from 'redux/actionsTypes';
import axios, { withCredentials } from 'util/axiosInstance';

export const getSharedDataContracts = () => async (dispatch: Function) => {
    dispatch({ type: dataManagerActionType.GET_DATA_MANAGER_SHARED });
    try {
        const resp = await axios().get('learnerserver/contract', withCredentials());
        dispatch({
            type: dataManagerActionType.GET_DATA_MANAGER_SHARED_SUCCESS,
            payload: resp.data.consentContract,
        });
    } catch (error) {
        dispatch({ type: notificationActionTypes.SHOW_TOP_ERROR_NOTIFICATION, message: 'Failed to load shared data, please contact support' });
    }
};

export const getExportedDataContracts = () => async (dispatch: Function) => {
    dispatch({ type: dataManagerActionType.GET_DATA_MANAGER_EXPORTED });
    try {
        const resp = await axios().get('learnerserver/export-data/vc', withCredentials());
        dispatch({
            type: dataManagerActionType.GET_DATA_MANAGER_EXPORTED_SUCCESS,
            payload: resp.data,
        });
    } catch (err) {
        dispatch({ type: notificationActionTypes.SHOW_TOP_ERROR_NOTIFICATION, message: 'Failed to load exported data, please contact support' });
    }
}